<template>
    <el-dialog title="请选择要上传的平台" :visible.sync="dialogVisible" width="600px">
        <div class="content">
            <el-row :gutter="20" v-if="1 > 2">
                <el-col :span="6">
                    <div @click="handleClick('淘宝')" class="platform">
                        <el-image :src="require('@/assets/imgs/platform/taobao.png')" width="100%" height="100%" />
                        <div class="text">淘宝</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div @click="handleClick('天猫')" class="platform">
                        <el-image :src="require('@/assets/imgs/platform/tm.png')" width="100%" height="100%" />
                        <div class="text">天猫</div>
                    </div>

                </el-col>
                <el-col :span="6">
                    <div @click="handleClick('京东')" class="platform">
                        <el-image :src="require('@/assets/imgs/platform/jingdong.png')" width="100%" height="100%" />
                        <div class="text">京东</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div @click="handleClick('拼多多')" class="platform">
                        <el-image :src="require('@/assets/imgs/platform/pinduoduo.png')" width="100%" height="100%" />
                        <div class="text">拼多多</div>
                    </div>

                </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 30px;">
                <el-col :span="6">
                    <div @click="handleClick('抖音')" class="platform">
                        <el-image :src="require('@/assets/imgs/platform/douyin.png')" width="100%" height="100%" />
                        <div class="text">抖音</div>
                    </div>

                </el-col>
                <el-col :span="6">
                    <div @click="handleClick('快手')" class="platform">
                        <el-image :src="require('@/assets/imgs/platform/kuaishou.png')" width="100%" height="100%" />
                        <div class="text">快手</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div @click="handleClick('视频号')" class="platform">
                        <el-image :src="require('@/assets/imgs/platform/shipinhao.png')" width="100%" height="100%" />
                        <div class="text">视频号</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div @click="handleClick('小红书')" class="platform">
                        <el-image :src="require('@/assets/imgs/platform/xiaohongshu.png')" width="100%" height="100%" />
                        <div class="text">小红书</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
    </el-dialog>
</template>

<script>

export default {
    name: "UploadToPlatform",
    data() {
        return {
            dialogVisible: false,
            goodsId: '',
            platform: '',
        };
    },
    created() { },
    mounted() { },
    methods: {
        /**
         * 打开弹窗
         * @param goodsId 
         */
        showPlatForm(goodsId) {
            this.goodsId = goodsId;
            this.dialogVisible = true;
        },
        /**
         * 点击跳转
         * @param platform
         */
        handleClick(platform) {
            const url = `https://www.toysmodel.cn/api/mini/goods/upload/view/${this.goodsId}/${platform}`
            window.open(url, '_blank');
        },
    },
};
</script>

<style scoped>
.content {
    padding: 10px 20px 0 20px;
}
.platform {
    width: 100px;
    height: 100px;
    border-radius: 10px;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.text {
    width: 64px;
    text-align: center;
}
</style>